// CSS
import './BookmarkInstance.css';
// React Hooks
import { useState, useEffect } from 'react';
// Skybase hooks
import { API_BASE_URL } from '../../../config';
// External Hooks/Components
import { useAuth as useClerkAuth } from '@clerk/react';
// Media Assets
import DocIcon from '../../../assets/StandardIcons/DocumentIcons/document-icon.png';


// Function component
function BookmarkInstance({ 
    documentID,
 }){

    // Init hooks
    const { getToken } = useClerkAuth();

    // =================
    // FETCH ENTITY JSON
    // =================
    const [documentJson, setDocumentJson] = useState(null);
    useEffect(() => {
        fetchDocumentJson();
    }, [documentID])

    async function fetchDocumentJson() {

        // Clerk JWT Authe.
        const token = await getToken();
        if (!token) { return }; // never fetch() if Clerk JWT DNE.
        const urlConfigs = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };

        // GET /documents/{id}
        const url = new URL(`${API_BASE_URL}/api/v1/documents/${documentID}`);
        const res = await fetch(url, urlConfigs);
        if (!res.ok) { throw new Error(`Unable to fetch() document with ID: ${documentID}.`)}
        const doc_json = await res.json();

        // ⚠️ developer debugging
        // console.log(`SKYBASE (client): Bookmark JSON`);
        // console.log(doc_json);

        // trigger re-render
        setDocumentJson(doc_json);
    }


    // MetaData (define using ternary operator)
    const entityIcon = <img className='BookmarkInstance-document-icon' src={DocIcon} alt='Document Icon.'/>;
    
    if (!documentJson) {
        return (
            <div className='BookmarkInstance-animation-placeholder'></div>
        )
    }

    // JSX Component
    return(
        <div className='BookmarkInstance'>
            
            {/* Icon */}
            <div className='BookmarkInstance-icon-col'>{entityIcon}</div>

            {/* Metadata */}
            <div className='BookmarkInstance-metadata-col'>
                
                {/* Bookmark name */}
                <div className='BookmarkInstance-metadata-name' >{documentJson?.name}</div>

                {/* Bookmark updated at */}
                <div className='BookmarkInstance-metadata--last-modified-text'>{new Date(documentJson?.updated_at).toLocaleDateString("en-US", {month: "long", day: "numeric", year: "numeric" })}</div>
            </div>
        </div>
    );
};


// Export statement
export default BookmarkInstance;